(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_selling-plan"] && !Shopify.designMode) return;
  try {
    /**
   * Keeps the toggle in sync with the selected variant.
   *
   * product-form.js only morphs the add-to-cart button, quantity selector,
   * price-per-item and volume pricing on a variant change — it never touches this
   * block — so without this the plan id and the prices shown here would go stale.
   *
   * The event name is the literal value of StandardEvents.productSelect
   * ('shopify:product:select'). This file's script is not a module, so the
   * constant cannot be imported here.
   */
  if (!customElements.get('wm-selling-plan')) {
    customElements.define(
      'wm-selling-plan',
      class WmSellingPlan extends HTMLElement {
        connectedCallback() {
          this.handleProductSelect = this.handleProductSelect.bind(this);
          this.scope = this.closest('.shopify-section, dialog, product-card');
          if (this.scope) this.scope.addEventListener('shopify:product:select', this.handleProductSelect);
        }

        disconnectedCallback() {
          if (this.scope) this.scope.removeEventListener('shopify:product:select', this.handleProductSelect);
        }

        handleProductSelect(event) {
          const promise = event && event.promise;
          if (!promise || typeof promise.then !== 'function') return;

          const input = this.querySelector('input[name="selling_plan"]');
          const wasChecked = Boolean(input && (input.type === 'hidden' || input.checked));

          promise
            .then((result) => {
              const html = result && result.detail && result.detail.html;
              if (!html) return;

              const next = html.querySelector('wm-selling-plan');

              // No plan for the newly selected variant — drop the input entirely so
              // nothing can be submitted for it.
              if (!next) {
                this.innerHTML = '';
                this.hidden = true;
                return;
              }

              this.hidden = false;
              this.className = next.className;
              this.setAttribute('style', next.getAttribute('style') || '');
              this.innerHTML = next.innerHTML;

              const newInput = this.querySelector('input[name="selling_plan"]');
              if (newInput && newInput.type === 'checkbox') newInput.checked = wasChecked;
            })
            .catch(() => {
              /* variant fetch failed or was aborted — leave the current state alone */
            });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wm-scroll-group"] && !Shopify.designMode) return;
  try {
    (function () {
    function initScroller(scroller) {
      if (scroller.dataset.wmDragScroll === 'true') return;
      scroller.dataset.wmDragScroll = 'true';

      var isDown = false;
      var isDragging = false;
      var startX = 0;
      var startScrollLeft = 0;

      scroller.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse') return;
        if (event.button !== 0) return;
        if (scroller.scrollWidth <= scroller.clientWidth) return;

        isDown = true;
        isDragging = false;
        startX = event.clientX;
        startScrollLeft = scroller.scrollLeft;
        scroller.setPointerCapture(event.pointerId);
      });

      scroller.addEventListener('pointermove', function (event) {
        if (!isDown) return;

        var deltaX = event.clientX - startX;
        if (Math.abs(deltaX) > 4) {
          isDragging = true;
          scroller.classList.add('is-dragging');
        }

        if (isDragging) {
          event.preventDefault();
          scroller.scrollLeft = startScrollLeft - deltaX;
        }
      });

      function endDrag(event) {
        if (!isDown) return;

        isDown = false;
        scroller.classList.remove('is-dragging');

        if (scroller.hasPointerCapture(event.pointerId)) {
          scroller.releasePointerCapture(event.pointerId);
        }

        if (isDragging) {
          scroller.dataset.wmSuppressClick = 'true';
          window.setTimeout(function () {
            delete scroller.dataset.wmSuppressClick;
          }, 0);
        }
      }

      scroller.addEventListener('pointerup', endDrag);
      scroller.addEventListener('pointercancel', endDrag);
      scroller.addEventListener('lostpointercapture', function () {
        isDown = false;
        scroller.classList.remove('is-dragging');
      });

      scroller.addEventListener(
        'click',
        function (event) {
          if (scroller.dataset.wmSuppressClick === 'true') {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        true
      );
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.wm-scroll-group__content').forEach(initScroller);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wm-video-hover"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wm-video-hover')) {
    customElements.define('wm-video-hover', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('.wm-video-hover__video');
        this.playBtn = this.querySelector('.wm-video-hover__play');
        if (!this.video) return;

        this.forceMuted = this.dataset.mute === 'true';
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this._onEnter = () => { if (!this.reduceMotion) this.play(); };
        this._onLeave = () => { if (!this.reduceMotion) this.pause(); };
        this._onToggle = (event) => {
          event.preventDefault();
          if (this.video.paused) { this.play(); } else { this.pause(); }
        };
        this._onOther = (event) => { if (event.detail !== this) this.pause(); };
        this._onEnded = () => { if (!this.video.loop) this.setPlaying(false); };

        this.addEventListener('mouseenter', this._onEnter);
        this.addEventListener('mouseleave', this._onLeave);
        if (this.playBtn) this.playBtn.addEventListener('click', this._onToggle);
        this.video.addEventListener('click', this._onToggle);
        this.video.addEventListener('ended', this._onEnded);
        document.addEventListener('wm-video-hover:play', this._onOther);
      }

      disconnectedCallback() {
        this.removeEventListener('mouseenter', this._onEnter);
        this.removeEventListener('mouseleave', this._onLeave);
        if (this.playBtn) this.playBtn.removeEventListener('click', this._onToggle);
        if (this.video) {
          this.video.removeEventListener('click', this._onToggle);
          this.video.removeEventListener('ended', this._onEnded);
          this.video.pause();
        }
        document.removeEventListener('wm-video-hover:play', this._onOther);
      }

      play() {
        if (!this.video) return;
        document.dispatchEvent(new CustomEvent('wm-video-hover:play', { detail: this }));
        this.video.muted = this.forceMuted;
        const attempt = this.video.play();
        if (attempt && attempt.then) {
          attempt
            .then(() => this.setPlaying(true))
            .catch(() => {
              this.video.muted = true;
              this.video.play().then(() => this.setPlaying(true)).catch(() => {});
            });
        } else {
          this.setPlaying(true);
        }
      }

      pause() {
        if (!this.video) return;
        this.video.pause();
        this.setPlaying(false);
      }

      setPlaying(isPlaying) {
        if (isPlaying) {
          this.setAttribute('data-playing', '');
        } else {
          this.removeAttribute('data-playing');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
